import React from 'react';

const CustomNavPrev = () => {
	return (
		<span className="ic ic-button-arrow-prev"></span>
	); 
}

export default CustomNavPrev;